import LogoImage from "./LogoImage";

const Logo = () => {
  return (
    <div className="framer-1n2yrmf !w-[130px]" data-framer-name="Logo">
      <LogoImage />
      {/* <LogoText /> */}
    </div>
  );
};

export default Logo;
